(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-banner"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initCountdowns(root) {
    (root || document).querySelectorAll('.ibanner-countdown[data-end]').forEach(function (el) {
      var endStr    = el.dataset.end;
      var endText   = el.dataset.endText || '';
      var hideOnEnd = el.dataset.hideOnEnd === 'true';
      if (!endStr) return;

      var endMs = new Date(endStr).getTime();
      if (isNaN(endMs)) return;

      var numD = el.querySelector('[data-days]');
      var numH = el.querySelector('[data-hours]');
      var numM = el.querySelector('[data-mins]');
      var numS = el.querySelector('[data-secs]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = endMs - Date.now();
        if (diff <= 0) {
          if (hideOnEnd) {
            el.style.display = 'none';
          } else if (endText) {
            el.innerHTML = '<div class="ibanner-countdown__end">' + endText + '</div>';
          }
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (numD) numD.textContent = pad(d);
        if (numH) numH.textContent = pad(h);
        if (numM) numM.textContent = pad(m);
        if (numS) numS.textContent = pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountdowns(); });
  } else {
    initCountdowns();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initCountdowns(e.target);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-configurator"] && !Shopify.designMode) return;
  try {
    

(function () {
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var amountComma = amount.replace('.', ',');
    return (format || '{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals);
  }

  function initConfigurator(section) {
    var id           = section.dataset.sectionId;
    var moneyFmt     = section.dataset.moneyFormat;
    var persoPrice   = parseInt(section.dataset.persoPrice, 10) || 0;
    var persoLabel   = section.dataset.persoLabel;
    var showPerso    = section.dataset.showPerso === 'true';

    var dataEl = document.getElementById('pconfig-data-' + id);
    if (!dataEl) return;

    var productData;
    try { productData = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants     = productData.variants || [];
    var options      = productData.options  || [];
    var selectedOpts = {};
    var currentVariant = null;
    var hasPerso     = false;

    var mainImg     = section.querySelector('.pconfig-main-img');
    var subtotalEl  = section.querySelector('.pconfig-subtotal-amount');
    var priceEl     = section.querySelector('.pconfig-group-price');
    var persoExtra  = section.querySelector('.pconfig-perso-extra');
    var msgEl       = section.querySelector('.pconfig-msg');
    var ctaBtn      = section.querySelector('.pconfig-cta');
    var persoFields = section.querySelectorAll('[data-perso-field]');

    function findVariant(opts) {
      return variants.find(function (v) {
        return options.every(function (name, idx) {
          var key = 'option' + (idx + 1);
          return !opts[name] || v[key] === opts[name];
        });
      });
    }

    function swapImage(src, alt) {
      if (!mainImg || !src) return;
      var loaded = false;
      var faded  = false;
      function doSwap() {
        if (!loaded || !faded) return;
        mainImg.src = src;
        if (alt !== undefined) mainImg.alt = alt;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            mainImg.classList.remove('pconfig-fading');
          });
        });
      }
      mainImg.classList.add('pconfig-fading');
      setTimeout(function () { faded = true; doSwap(); }, 150);
      var preload = new Image();
      preload.onload  = function () { loaded = true; doSwap(); };
      preload.onerror = function () { loaded = true; doSwap(); };
      preload.src = src;
    }

    function updateDisplay() {
      currentVariant = findVariant(selectedOpts);

      if (currentVariant) {
        var baseCents = currentVariant.price;
        var total = baseCents + (hasPerso ? persoPrice : 0);

        if (priceEl)    priceEl.textContent    = formatMoney(baseCents, moneyFmt);
        if (subtotalEl) subtotalEl.textContent = formatMoney(total, moneyFmt);

        if (ctaBtn) {
          ctaBtn.dataset.variantId = currentVariant.id;
        }

        if (currentVariant.featured_image && currentVariant.featured_image.src) {
          var imgSrc = currentVariant.featured_image.src;
          if (imgSrc.indexOf('?') === -1) imgSrc += '?width=800';
          swapImage(imgSrc, currentVariant.featured_image.alt || '');
        }
      }

      updatePillAvailability();
    }

    function updatePillAvailability() {
      section.querySelectorAll('.pconfig-pills[data-option-pos]').forEach(function (group) {
        var optName = group.dataset.optionName;
        var optPos  = parseInt(group.dataset.optionPos, 10);
        var optKey  = 'option' + optPos;

        group.querySelectorAll('.pconfig-pill').forEach(function (pill) {
          var val = pill.dataset.optionValue;
          var avail = variants.some(function (v) {
            if (v[optKey] !== val) return false;
            if (!v.available) return false;
            return options.every(function (oName, oIdx) {
              if (oName === optName) return true;
              var oKey = 'option' + (oIdx + 1);
              return !selectedOpts[oName] || v[oKey] === selectedOpts[oName];
            });
          });

          pill.disabled = !avail;
          pill.classList.toggle('is-unavailable', !avail);
          if (!avail && pill.classList.contains('is-active')) {
            pill.classList.remove('is-active');
            delete selectedOpts[optName];
          }
        });
      });
    }

    function showMsg(text, type) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.className = 'pconfig-msg' + (type ? ' is-' + type : '');
      if (type === 'success') {
        setTimeout(function () {
          msgEl.textContent = '';
          msgEl.className = 'pconfig-msg';
        }, 3500);
      }
    }

    function clearPersoFieldError(wrap) {
      wrap.classList.remove('is-error');
      var hint = wrap.parentElement && wrap.parentElement.querySelector('.pconfig-perso-hint');
      if (hint) hint.classList.remove('is-visible');
    }

    section.querySelectorAll('.pconfig-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        section.querySelectorAll('.pconfig-thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');

        var optName = this.dataset.optionName;
        var optVal  = this.dataset.optionValue;
        if (optName) selectedOpts[optName] = optVal;

        if (this.dataset.imgSrc) {
          swapImage(this.dataset.imgSrc, this.dataset.imgAlt || '');
        }

        updateDisplay();
      });
    });

    section.querySelectorAll('.pconfig-pills[data-option-pos]').forEach(function (group) {
      group.querySelectorAll('.pconfig-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (this.disabled || this.classList.contains('is-unavailable')) return;
          var optName = this.dataset.optionName;
          group.querySelectorAll('.pconfig-pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          this.classList.add('is-active');
          selectedOpts[optName] = this.dataset.optionValue;
          updateDisplay();
        });
      });
    });

    persoFields.forEach(function (wrap) {
      var inp = wrap.querySelector('.pconfig-perso-input');
      if (!inp) return;

      if (inp.dataset.persoType === 'year') {
        inp.addEventListener('input', function () {
          var clean = this.value.replace(/\D/g, '').slice(0, 4);
          if (this.value !== clean) this.value = clean;
        });
        inp.addEventListener('keydown', function (e) {
          var allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'];
          if (allowed.indexOf(e.key) === -1 && !/^\d$/.test(e.key) && !e.ctrlKey && !e.metaKey) {
            e.preventDefault();
          }
        });
      }

      inp.addEventListener('input', function () {
        clearPersoFieldError(wrap);
        hasPerso = Array.from(persoFields).some(function (w) {
          var i = w.querySelector('.pconfig-perso-input');
          return i && i.value.trim().length > 0;
        });
        if (persoExtra) {
          persoExtra.textContent = hasPerso
            ? '+ ' + formatMoney(persoPrice, moneyFmt)
            : '';
        }
        updateDisplay();
      });
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        if (!currentVariant) return;

        var persoValid = true;
        var firstInvalid = null;
        persoFields.forEach(function (wrap) {
          var inp = wrap.querySelector('.pconfig-perso-input');
          if (inp && !inp.value.trim()) {
            wrap.classList.add('is-error');
            var hint = wrap.parentElement && wrap.parentElement.querySelector('.pconfig-perso-hint');
            if (hint) hint.classList.add('is-visible');
            if (!firstInvalid) firstInvalid = inp;
            persoValid = false;
          }
        });
        if (!persoValid) {
          if (firstInvalid) firstInvalid.focus();
          return;
        }

        if (!currentVariant.available) return;

        var body = { id: currentVariant.id, quantity: 1 };

        var props = {};
        persoFields.forEach(function (wrap) {
          var inp = wrap.querySelector('.pconfig-perso-input');
          if (inp && inp.value.trim()) {
            props[inp.dataset.persoKey || 'Personalization'] = inp.value.trim();
          }
        });
        if (Object.keys(props).length > 0) {
          body.properties = props;
        }

        ctaBtn.disabled = true;
        showMsg('', '');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'error'); });
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open',    { bubbles: true }));
            showMsg('Added to cart!', 'success');
          })
          .catch(function (err) {
            showMsg(err.message || 'Could not add to cart. Please try again.', 'error');
          })
          .finally(function () {
            ctaBtn.disabled = !currentVariant.available;
          });
      });
    }

    section.querySelectorAll('.pconfig-thumb.is-active').forEach(function (t) {
      var on = t.dataset.optionName;
      var ov = t.dataset.optionValue;
      if (on) selectedOpts[on] = ov;
    });
    section.querySelectorAll('.pconfig-pill.is-active').forEach(function (p) {
      selectedOpts[p.dataset.optionName] = p.dataset.optionValue;
    });

    currentVariant = findVariant(selectedOpts);
    if (ctaBtn && currentVariant) {
      ctaBtn.disabled = !currentVariant.available;
      ctaBtn.dataset.variantId = currentVariant.id;
    }
    updatePillAvailability();
  }

  function boot() {
    document.querySelectorAll('.pconfig-section[data-section-id]').forEach(initConfigurator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pconfig-section[data-section-id]');
    if (s) initConfigurator(s);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
